import { ReportPaginateResponseData } from '../utils/reportPaginate.util'
import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'

export interface PackTraceBundleData {
  id: number
  packTraceId: number
  code: string
}

export interface PackTraceReportPaginateRequest
  extends PackTraceReportExportRequest, PaginateRequest {}

export type PackTraceReportPaginateResponse = PaginateResponse<ReportPaginateResponseData[]>

export interface PackTraceReportExportRequest {
  startAt?: string
  endAt?: string
  item?: number
}

const routes = {
  paginateReport: '/packTraceBundles/report/paginate',
  exportReport: '/packTraceBundles/report/export'
}

export default {
  paginateReport (
    params: PackTraceReportPaginateRequest,
    callback: ResponseCallback<PackTraceReportPaginateResponse>
  ) {
    api.get(routes.paginateReport, params, callback)
  },

  exportReport (
    params: PackTraceReportExportRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.get(routes.exportReport, params, callback)
  }
}
